<template>
    <section id="AboutUs" class="AboutUs white">
        <div class="row container">
            <div class="col s12 m12 l12 xl12 center-text description">
                <div class="title"><img src="/assets/images/aboutus2.png"></div>
                We at the House of Fire Christian Church are all about growing together as a church family while increasing our biblical knowledge and, most importantly, drawing closer to Jesus Christ in our personal spritual journeys.<br><br>
                In the summer of 2017, we were overjoyed to finally open the doors of our new church building in Clifton, New Jersey, after over a decade of patience and determination. We welcome you to join us as we worship our heavenly Father, learn more about the Word of God, and fellowship with one another.<br><br> 
                "After 15 years of perseverance, we are proud to finally worship in our new church building. It has been a difficult journey, fighting for our vision and God has answered our prayers. As James 5:16 says, 'The fervent prayer of a righteous man can bring powerful results.' We are overjoyed to worship the Lord in our new home, and look forward to welcoming everyone into this new chapter that God has in store for us." &ndash; Rev. Placido Lentini
            </div>
        </div>
        <div class="row container church">
            <div class="col s12 m12 l4 xl4">
                <img class="materialboxed" src="/assets/images/about/ribbon.jpg">
            </div>
            <div class="col s12 m12 l4 xl4">
                <img class="materialboxed" src="/assets/images/about/service.jpg">
            </div>
            <div class="col s12 m12 l4 xl4">
                <img class="materialboxed" src="/assets/images/about/fellowship.jpg">
            </div>
        </div>
        <div class="row">
            <div class="col s12 center button-div">
                <router-link class="waves-effect waves-light btn-large" :to="{name: 'gallery'}">Gallery</router-link>
            </div>  
        </div>
    </section>
</template>

<script>
    import M from 'materialize-css'

    // import VueRouter from 'vue-router'
    export default {
        name: 'AboutUs',
        mounted: function() { 
            var elems = document.querySelectorAll('.materialboxed');
            M.Materialbox.init(elems, {});
        },
    }
</script>

<style scoped>
    .row { 
        margin-bottom: 0;
    }
    .title {
        font-weight: normal;
        font-size: 2.5rem;
        margin-bottom: 1rem;
        letter-spacing: .06rem;
        text-align: center;
    }

    .image {
        padding-right: 0;
        background: url(/assets/images/church2.jpg);
        background-size: cover;
        background-position: center;
        height: 770px;
        /* filter: grayscale(100%); */
    }

    .AboutUs .image img {
        width: 100%;
    }

    .church div {
        margin-bottom: 15px;
    }

    .description {
        padding: 4rem 0rem 4rem 0rem;
        font-size: 1.25rem;
        line-height: 1.25;
    }

    .church {
        padding-bottom: 2.5rem;
    }
    .church img {
        width: 100%;
    }

    .button-div {
        margin-bottom: 4rem;
    }

    .button-div a {
        line-height: 58px;
        font-size: 1.4rem;
        padding: 0px 50px;
        background: rgba(91,124,138, 1);
    }

    .button-div a:hover {
        background: rgba(91,124,138, .7);
        color: #fff;
    }
</style>